import React from 'react';
import axios from 'axios';
import {Route, Switch, withRouter} from "react-router-dom";
import {connect} from "react-redux";

import NewsfeedList from "./NewsfeedList";
import NewsfeedPreview from "./NewsfeedPreview";
import NewsfeedForm from "./NewsfeedForm";
import * as NotificationsActionCreators from "../../redux/actions/notificationsActions";

import './style.css';

class Newsfeeds extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            size: {
                width: null,
                height: null
            }
        };

        this.handleAddNewsfeed = this.handleAddNewsfeed.bind(this);
        this.handleEditNewsfeed = this.handleEditNewsfeed.bind(this);
        this.handleRemoveNewsfeed = this.handleRemoveNewsfeed.bind(this);
        this.handleChangeEnabled = this.handleChangeEnabled.bind(this);
    }

    handleAddNewsfeed(values) {
        let token = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };
        axios.post(this.props.api.newsfeeds, {
            ...values,
        }, config).then((response) => {
            this.props.addNotification('success', response.status, 'Novinka ' + response.data.name + ' byla vytvořena.');
            this.props.history.push('/newsfeeds');
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Novinku se nepodařilo vytvořit!');
            this.props.history.push('/newsfeeds');
            console.error('Axios error:', error);
        });
    }

    handleEditNewsfeed(values) {
        let token = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };
        axios.put(this.props.api.newsfeeds + "/" + values.id, {
            ...values,
        }, config).then((response) => {
            this.props.addNotification('success', response.status, 'Novinka ' + response.data.name + ' byla upravena.');
            this.props.history.push('/newsfeeds');
        }).catch(function (error) {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Novinku se nepodařilo upravit!');
            this.props.history.push('/newsfeeds');
            console.error('Axios error:', error);
        });
    }

    handleRemoveNewsfeed(newsfeed) {
        let token = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };
        axios.delete(this.props.api.newsfeeds + "/" + newsfeed.id, config)
        .then((response) => {
            if (!this._calledComponentWillUnmount) {
                this.props.addNotification('success', response.status, 'Novinka ' + newsfeed.name + ' byla odstraněna.');
            }
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Novinku se nepodařilo odstranit!');
            console.log("Axios error: ", error);
        });
    }

    handleChangeEnabled(newsfeed){
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };

        const enabled = !newsfeed.enabled;

        axios.put(this.props.api.newsfeeds + "/" + newsfeed.id, {
            enabled
        }, config).then((response) => {
            if (!newsfeed.enabled) {
                this.props.addNotification('success', response.status, 'Novinka ' + newsfeed.name + ' byla povolena.');
            } else {
                this.props.addNotification('success', response.status, 'Novinka ' + newsfeed.name + ' byla zakázána.');
            }
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Novinku se nepodařilo '+(enabled ? 'povolit' :  'zakázat')+'!');
            console.log("Axios error: ", error);
        })
    }

    render() {
        return (
            <div id="newsfeeds-page" className="right-col" role="main">
                <div className="page-title">
                    <div className="title-left">
                        <h3>Novinky</h3>
                    </div>
                </div>
                <Switch>
                    <Route exact path='/newsfeeds' component={() =>
                        <NewsfeedList
                            {...this.props}
                            handleChangeEnabled={this.handleChangeEnabled}
                            handleRemoveNewsfeed={this.handleRemoveNewsfeed}
                        />
                    }
                    />
                    <Route exact path='/newsfeeds/add' component={() =>
                        <NewsfeedForm
                            {...this.props}
                            title="Formulář pro přidání novinky"
                            button="Přidat"
                            size={this.state.size}
                            action={this.handleAddNewsfeed}
                        />
                    }
                    />
                    <Route exact path='/newsfeeds/edit/:id' component={() =>
                        <NewsfeedForm
                            {...this.props}
                            title="Formulář pro úpravu novinky novinky"
                            button="Upravit"
                            size={this.state.size}
                            action={this.handleEditNewsfeed}
                        />
                    }
                    />
                    <Route exact path='/newsfeeds/preview/:id' component={() =>
                        <NewsfeedPreview
                            {...this.props}
                        />
                    }
                    />
                </Switch>
            </div>
        );
    }
}

const mapStateToProps = function(state){
    return {
        notifications: state.notifications,
    }
};

const mapDispatchToProps = function (dispatch) {
    return {
        addNotification: (type, status, message) => dispatch(NotificationsActionCreators.addNotification(type, status, message)),
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Newsfeeds));



/** WEBPACK FOOTER **
 ** ./src/containers/Newsfeeds/index.js
 **/